module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products"
  }, [_c('el-dialog', {
    attrs: {
      "title": "编辑产品",
      "visible": _vm.dialogVisible,
      "modal": _vm.modal,
      "before-close": _vm.closeDialog,
      "width": "700px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('div', [_vm._v("产品数：" + _vm._s(_vm.idArr.length))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addProducts
    }
  }, [_vm._v("添加产品")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.selectProducts,
      "border": "",
      "height": "360"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.tableClick($event)
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "el-icon-circle-close delete",
          attrs: {
            "data-type": "del",
            "data-index": scope.$index
          }
        })]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.tableHead[_vm.moduleName]), function(name, attr) {
    return _c('el-table-column', {
      key: attr,
      attrs: {
        "show-overflow-tooltip": true,
        "prop": attr,
        "label": name,
        "width": _vm.getWidth(attr)
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(attr === 'name') ? [_c('p', {
            staticClass: "productNo"
          }, [_vm._v(_vm._s(scope.row.productNo))]), _vm._v(" "), _c('el-tooltip', {
            attrs: {
              "effect": "dark",
              "content": scope.row.name,
              "placement": "top-start"
            }
          }, [_c('p', {
            staticClass: "name"
          }, [(scope.row.productPrice === 0 || scope.row.productPrice === '0.00') ? _c('span', {
            staticClass: "gift"
          }, [_vm._v("[赠品]")]) : _vm._e(), _vm._v(_vm._s(scope.row.name))])])] : (attr === 'discount') ? _c('div', [_c('el-input', {
            attrs: {
              "size": "small"
            },
            on: {
              "change": function($event) {
                _vm.discountChange(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.discount),
              callback: function($$v) {
                _vm.$set(scope.row, "discount", _vm._n($$v))
              },
              expression: "scope.row.discount"
            }
          })], 1) : (attr === 'productPrice') ? _c('div', [_c('el-input', {
            attrs: {
              "size": "small"
            },
            on: {
              "change": function($event) {
                _vm.priceChange(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.productPrice),
              callback: function($$v) {
                _vm.$set(scope.row, "productPrice", _vm._n($$v))
              },
              expression: "scope.row.productPrice"
            }
          })], 1) : (attr === 'num') ? _c('div', [_c('el-input', {
            attrs: {
              "size": "small",
              "min": 0
            },
            on: {
              "change": function($event) {
                _vm.numChange(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.num),
              callback: function($$v) {
                _vm.$set(scope.row, "num", _vm._n($$v))
              },
              expression: "scope.row.num"
            }
          })], 1) : (attr === 'memo') ? _c('div', [_c('el-input', {
            attrs: {
              "type": "textarea",
              "autosize": {
                minRows: 1,
                maxRows: 3
              }
            },
            model: {
              value: (scope.row.memo),
              callback: function($$v) {
                _vm.$set(scope.row, "memo", $$v)
              },
              expression: "scope.row.memo"
            }
          })], 1) : (attr === 'specification') ? _c('div', [_vm._v("\n              " + _vm._s(scope.row.specification || '--') + "\n            ")]) : (attr === 'totalPrice') ? _c('div', [_vm._v("\n              " + _vm._s(Number(Number(scope.row.totalPrice).toFixed(6))) + "\n            ")]) : _c('div', [_vm._v("\n              " + _vm._s(scope.row[attr] || (scope.row[attr] === 0 ? 0 : '--')) + "\n            ")])]
        }
      }])
    })
  })], 2), _vm._v(" "), (['workOrder'].indexOf(_vm.moduleName) === -1) ? _c('div', {
    staticClass: "statistics"
  }, [_c('div', {
    staticClass: "totalPrice"
  }, [_vm._v("产品合计(元)：" + _vm._s(_vm.totalPrice))]), _vm._v(" "), (_vm.surchargeArr && _vm.surchargeArr.length) ? _c('div', {
    staticClass: "otherPrice"
  }, _vm._l((_vm.surchargeArr), function(item, index) {
    return _c('span', {
      staticClass: "price",
      class: {
        'discounts': item.surchargeType === 2
      }
    }, [_c('label', [_vm._v(_vm._s(item.surchargeName) + "(元)：" + _vm._s(item.surchargeType === 2 ? '-' : '+'))]), _vm._v(" "), _c('el-input', {
      ref: 'surcharge' + index,
      refInFor: true,
      attrs: {
        "size": "small"
      },
      on: {
        "change": function($event) {
          _vm.changePrice()
        },
        "blur": function($event) {
          _vm.changePrice(index, 'blur', item.amount)
        }
      },
      model: {
        value: (item.amount),
        callback: function($$v) {
          _vm.$set(item, "amount", _vm._n($$v))
        },
        expression: "item.amount"
      }
    })], 1)
  })) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), (['workOrder'].indexOf(_vm.moduleName) > -1) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('el-button', {
    staticClass: "editBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取 消")])], 1)]) : _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', [_vm._v(_vm._s(_vm.title) + "金额：" + _vm._s(_vm.contractPrice))]), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "editBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取 消")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-120344d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/products.vue
// module id = 1216
// module chunks = 82